export default __webpack_public_path__ + "static/media/maintainpage-countdownbg.837068b4.svg";